import React from "react";

function Content() {
  return (
    <div className="absolute right-0 mt-5">
      <div className="w-64 text-left bg-white rounded-lg shadow-lg">
        <div className="flex items-center px-6 py-4">
          <img
            className="h-10 w-10 rounded-full flex-no-shrink"
            src="https://images.unsplash.com/photo-1541271696563-3be2f555fc4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=1.75&w=200&h=200&q=80"
            alt=""
          />
          <div className="ml-4">
            <p className="font-semibold text-gray-900 leading-none">
              Margot Foster
            </p>
            <p>
              <a
                href="#"
                className="text-sm text-gray-600 leading-none hover:underline"
              >
                View Profile
              </a>
            </p>
          </div>
        </div>
        <div className="border-t-2 border-gray-200 py-1">
          <a
            href="#"
            className="block px-6 py-3 leading-tight hover:bg-gray-200"
          >
            Settings and Privacy
          </a>
          <a
            href="#"
            className="block px-6 py-3 leading-tight hover:bg-gray-200"
          >
            Language
          </a>
        </div>
        <div className="border-t-2 border-gray-200 py-1">
          <a
            href="#"
            className="block px-6 py-3 leading-tight hover:bg-gray-200"
          >
            Advertise
          </a>
          <a
            href="#"
            className="block px-6 py-3 leading-tight hover:bg-gray-200"
          >
            Analytics
          </a>
        </div>
        <form
          className="border-t-2 border-gray-200 py-1"
          action="#"
          method="POST"
        >
          <button className="block w-full px-6 py-3 text-left leading-tight hover:bg-gray-200">
            Sign out
          </button>
        </form>
      </div>
    </div>
  );
}

export default Content;
